import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { ShopItemDetailsCard } from '@swyftx/features/shop/components';

import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

type Params = {
  itemId?: string;
};

type State = {
  selectedVariant?: number;
};

const ShopItem: React.FC = () => {
  const { itemId } = useParams<Params>();
  const { selectedVariant } = (useLocation().state || {}) as State;
  const { navigate } = useNavigateRoute();

  if (!itemId) return <Navigate to={NavigationURLs.Shop} />;

  return (
    <ShopItemDetailsCard
      itemId={itemId}
      initialSelectedVariant={selectedVariant}
      onBack={() => navigate(NavigationURLs.Shop)}
    />
  );
};

export default ShopItem;
